import { render, staticRenderFns } from "./Brackets.vue?vue&type=template&id=fa676f4e&scoped=true"
import script from "./Brackets.vue?vue&type=script&lang=js"
export * from "./Brackets.vue?vue&type=script&lang=js"
import style0 from "./Brackets.vue?vue&type=style&index=0&id=fa676f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa676f4e",
  null
  
)

export default component.exports